// extracted by mini-css-extract-plugin
export default {"container":"style_container__gW8kd","content":"style_content__ImEjJ","header":"style_header__SftKb","description":"style_description__hABDs","CTA":"style_CTA__z5ZTn"};